export default {"src":"/_next/static/media/curation_2.4e4ce250.gif","height":560,"width":500,"blurWidth":0,"blurHeight":0};